import React from "react"
import { FocusModeSlideOut } from "./focus-mode-slide-out"
import { FocusModeHide } from "./focus-mode-hide"

export const FocusModeSlideOutAndHide = React.forwardRef(
  ({ children, ...props }, ref) => {
    return (
      <FocusModeSlideOut {...props} ref={ref}>
        <FocusModeHide>{children}</FocusModeHide>
      </FocusModeSlideOut>
    )
  }
)
